import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../../i18n";

export const Ribbon = () => {
  const { t } = useLang();
  return (
    <section className="py-10 md:py-16 border-y border-white/10 bg-[#070708] overflow-hidden">
      <Marquee speed={45} gradient={false}>
        {t.marquee.concat(t.marquee).map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-black uppercase text-[8vw] md:text-[6vw] leading-none marquee-outline mx-6">
              {w}
            </span>
            <span className="text-primary-c text-[6vw] md:text-[4vw]">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
